module.exports = __webpack_public_path__ + "img/NationalUrbanLeague.90cc9a51.png";